import {
  SPH_OPTIONS,
  CYL_OPTIONS,
  AXIS_OPTIONS,
} from "./prescription-constants.js";

const selectGroup = document.querySelectorAll(".form-group-select");

if (selectGroup) {
  let rightSphSelect = document.querySelector(
    '.form-group-select[name="right_sph"]'
  );
  let rightCylSelect = document.querySelector(
    '.form-group-select[name="right_cyl"]'
  );
  let rightAxisSelect = document.querySelector(
    '.form-group-select[name="right_axis"]'
  );
  let leftSphSelect = document.querySelector(
    '.form-group-select[name="left_sph"]'
  );
  let leftCylSelect = document.querySelector(
    '.form-group-select[name="left_cyl"]'
  );
  let leftAxisSelect = document.querySelector(
    '.form-group-select[name="left_axis"]'
  );

  if (
    rightSphSelect ||
    leftSphSelect ||
    rightCylSelect ||
    leftCylSelect ||
    rightAxisSelect ||
    leftAxisSelect
  ) {
    SPH_OPTIONS.forEach((o) => {
      rightSphSelect.add(new Option(o.label, o.value));
      leftSphSelect.add(new Option(o.label, o.value));
    });
    CYL_OPTIONS.forEach((o) => {
      rightCylSelect.add(new Option(o.label, o.value));
      leftCylSelect.add(new Option(o.label, o.value));
    });
    AXIS_OPTIONS.forEach((o) => {
      rightAxisSelect.add(new Option(o.label, o.value));
      leftAxisSelect.add(new Option(o.label, o.value));
    });
  }
}
